export class WorkSpacePanels {
    dispatch = false;
    outbound = false;
    manageVans = false;
    myTasks = false;
    unassignedTasks = false;
    terminal = false;
    profile = false;
    settings = false;
    newTask = false;
    search = false;
    terminalruns = false;
    alerts = false;
    hide = true; //default
  }
